module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_chlodzenie.0e8d61e2.svg";